import { createComponent } from '@carvana/merch-components';
import {
  CommonHeading,
  CommonSection,
  ContentContainer
} from '~/components/flp/Financing.styles';

export const AllCreditTypesSection = createComponent(CommonSection, {
  className: 'pt-2xl sm:pb-7xl sm:pt-0 md:px-4xl'
});

export const Container = createComponent(ContentContainer, {
  className: 'flex max-w-[unset] flex-col gap-3xl sm:items-center sm:gap-4xl'
});

export const Header = createComponent('div', {
  className: 'flex flex-col gap-xl'
});

export const Heading = createComponent(CommonHeading, {
  className: 'sm:text-center'
});

export const Description = createComponent('p', {
  className: 'text-text-default t-body-md sm:text-center md:t-body-lg'
});

export const Content = createComponent('div', {
  className: 'flex flex-col gap-xl sm:flex-row'
});

export const PropositionHeading = createComponent('h2', {
  className: 'text-text-strong t-heading-lg'
});

export const PropositionCopy = createComponent('p', {
  className: 'text-text-default t-body-sm'
});
